import React, { useState } from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import DrawerMenu from "./DrawerMenu";
import LanguageSwitcher from "../LanguageSwitcher";
import DownloadCsvPage from "./Pages/DownloadCsvPage";
import styles from "./AdminHomePage.module.css";
import { IMAGES } from "../../utils/GetImages";
import { getTranslation } from "../../utils/translation";

export default function AdminHomePage() {
	const [activePage, setActivePage] = useState("downloadCsv");
	const { i18n } = useTranslation();

	const IconImg = IMAGES["Icon.png"];

	const renderContent = () => {
		switch (activePage) {
			case "downloadCsv":
				return <DownloadCsvPage />;
			default:
				return (
					<div>
						{getTranslation(i18n, "adminHomePage.notFoundError")}
					</div>
				);
		}
	};

	return (
		<div className={styles["admin-layout"]}>
			{/* Fixed Sidebar */}
			<div className={styles["sidebar"]}>
				<DrawerMenu
					onSelect={(key) => {
						setActivePage(key);
					}}
				/>
			</div>

			{/* Main Content Area */}
			<div className={styles["main-content"]}>
				{/* Header */}
				<div className={styles["admin-home-header"]}>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: "10px",
						}}
					>
						<img
							src={IconImg}
							alt="World Series Of Mahjong"
							style={{
								height: "35px",
								verticalAlign: "middle",
							}}
						/>
						<Typography
							variant="h5"
							style={{ textAlign: "center", color: "white" }}
						>
							{getTranslation(i18n, "adminHomePage.title")}
						</Typography>
					</div>
					<LanguageSwitcher />
				</div>

				{/* Page Content */}
				<div className={styles["content-area"]}>{renderContent()}</div>
			</div>
		</div>
	);
}
